/**
 * SavageTech Widget Theme Configuration
 *
 * Defines the visual theme for the Savage widget.
 */

export const defaultVendorTheme = {
    main: {
        primary: '#FFC42C',
        primaryForeground: '#000000',
        secondary: '#1D4743',
        secondaryForeground: '#02F7C8',
        accent: '#FEA832',
        accentForeground: '#FFFFFF',
        background: '#111316',
        cardBackground: '#0D0F11',
        hueRotation: '0deg',
    },
    borderGradients: {
        borderGradientMainFrom: '#F9D3A1',
        borderGradientMainTo: '#666666',
    },
};
